import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ca6653e")

_pushScopeId("data-v-1ca6653e")
const _hoisted_1 = { class: "flex-grow whitespace-nowrap" }
const _hoisted_2 = { class: "w-full py-3 bg-white" }
const _hoisted_3 = {
  class: "flex flex-col overflow-y-auto",
  style: {"max-height":"450px"}
}
const _hoisted_4 = { class: "flex space-x-3 items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex space-x-2 items-center cursor-wait"
}
const _hoisted_6 = { class: "text-12px text-gray-lp-800" }
const _hoisted_7 = {
  key: 1,
  class: "flex space-x-1 items-center cursor-default"
}
const _hoisted_8 = { class: "text-12px text-gray-lp-800" }
const _hoisted_9 = { class: "text-12px text-red-lp-300" }
const _hoisted_10 = {
  key: 3,
  class: "flex space-x-1 items-center cursor-default"
}
const _hoisted_11 = { class: "text-12px text-gray-lp-800" }
const _hoisted_12 = {
  key: 0,
  class: "px-6"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { id: "infinite-scroll" }, null, -1)
const _hoisted_15 = { class: "px-6 flex flex-col space-y-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", {
    class: ["fixed w-fit z-20 bottom-0 right-0 flex flex-col rounded-t-lg", {'pb-4': _ctx.isShowRunningText}],
    style: {"box-shadow":"0px 0px 15px rgba(26, 20, 33, 0.15)"}
  }, [
    _createVNode("div", {
      class: "w-full px-6 py-3 text-white bg-red-lp-300 text-16px font-semibold space-x-6 flex items-center cursor-pointer rounded-t-lg",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenu && _ctx.onToggleMenu(...args)))
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.customTitle || _ctx.$t("report.cards.reportSearch")), 1),
      (_ctx.isCloseable)
        ? (_openBlock(), _createBlock(_component_Icons, {
            key: 0,
            name: "close",
            class: "w-4 text-white",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("img", {
        alt: "chevron",
        class: "w-5",
        src: 
          require(`@/app/ui/assets/svg/chevron-${
            _ctx.isOpen ? 'down' : 'up'
          }-white.svg`)
        
      }, null, 8, ["src"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.downloadRequestList, (group, index) => {
          return (_openBlock(), _createBlock(_Fragment, {
            key: `${index}`
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
              return (_openBlock(), _createBlock(_Fragment, {
                key: `${itemIndex}`
              }, [
                _withDirectives(_createVNode("div", { class: "pl-6 text-black-lp-300 font-semibold bg-gray-lp-200 text-12px" }, _toDisplayString(item.dateString), 513), [
                  [_vShow, itemIndex === 0]
                ]),
                _createVNode("div", {
                  class: ["px-6 flex flex-col space-y-2 item-hovered", itemIndex === group.length - 1 ? 'pt-4 pb-6' : 'py-4']
                }, [
                  _createVNode("div", _hoisted_4, [
                    _withDirectives(_createVNode("div", {
                      class: ["flex-grow truncate text-black-lp-300 text-14px", 
                    `${
                      item.title.length > 37
                        ? 'cursor-pointer'
                        : 'cursor-default'
                    }`
                  ],
                      style: 
                    item.status === 'failed'
                      ? 'text-decoration: line-through;'
                      : ''
                  
                    }, [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ], 6), [
                      [
                        _directive_tooltip,
                        
                    `${item.title.length > 37 ? item.title : ''}`
                  ,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  (item.status === 'waiting')
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("img", {
                          alt: "loading",
                          class: "w-4 loader",
                          src: require(`@/app/ui/assets/svg/loading-gray.svg`)
                        }, null, 8, ["src"]),
                        _createVNode("span", _hoisted_6, " Generate " + _toDisplayString(item.type === "progressive-commission-report" ||
                    item.type === "mutation-saldo-report" ||
                    item.type === "hold_balance_history"
                      ? "xlsx"
                      : "csv") + " " + _toDisplayString(_ctx.numberOfFiles(item)), 1)
                      ]))
                    : (item.url === 'no-data')
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode("img", {
                            alt: "failed",
                            class: "w-5",
                            src: 
                    require(`@/app/ui/assets/svg/x-circle-outline-gray.svg`)
                  
                          }, null, 8, ["src"]),
                          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Data tidak ditemukan')), 1)
                        ]))
                      : (item.status === 'success' && item.url)
                        ? (_openBlock(), _createBlock("div", {
                            key: 2,
                            class: "flex space-x-2 items-center cursor-pointer",
                            onClick: ($event: any) => (_ctx.onDownload(item))
                          }, [
                            _createVNode("img", {
                              alt: "download",
                              class: "w-4",
                              src: require(`@/app/ui/assets/svg/download-new.svg`)
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_9, "Download " + _toDisplayString(_ctx.numberOfFiles(item)), 1)
                          ], 8, ["onClick"]))
                        : (_openBlock(), _createBlock("div", _hoisted_10, [
                            _createVNode("img", {
                              alt: "failed",
                              class: "w-5",
                              src: 
                    require(`@/app/ui/assets/svg/x-circle-outline-gray.svg`)
                  
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('report.cards.generateFailed')), 1)
                          ]))
                ], 2),
                (itemIndex < group.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 64))
        }), 128)),
        _hoisted_14,
        _withDirectives(_createVNode("div", _hoisted_15, [
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "90%",
            height: "20px"
          })
        ], 512), [
          [_vShow, _ctx.isLoading]
        ])
      ], 512), [
        [_vShow, _ctx.downloadRequestList.length > 0]
      ])
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 2))
})